export default "__VITE_ASSET__BSqJ3PtT__"